import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete_icon",
  "use": "icon-delete_icon-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-delete_icon\">\n  <title>shanchu</title>\n  <path d=\"M6.4 9.6c-0.001-0.023-0.002-0.049-0.002-0.075 0-0.843 0.683-1.526 1.526-1.526 0.027 0 0.053 0.001 0.079 0.002h3.084l0.336-2.162c0.158-0.602 0.698-1.039 1.339-1.039 0.013 0 0.026 0 0.039 0.001h6.398c0.008 0 0.017 0 0.026 0 0.64 0 1.178 0.437 1.332 1.029l0.002 0.010 0.352 2.162h3.088c0.851 0.077 1.523 0.749 1.599 1.593v1.607h-19.2v-1.6zM19.2 6.4h-6.4v1.6h6.4v-1.6zM8 12.8h16c0.878 0.013 1.587 0.722 1.6 1.599v0.001l-1.6 11.2c-0.256 0.896-1.045 1.549-1.995 1.6h-12.405c-0.853-0.072-1.528-0.747-1.6-1.594v-0.006l-1.6-11.2c0.013-0.878 0.722-1.587 1.599-1.6h0.001zM19.2 24.4h2.4l0.8-9.8h-3.2v9.8zM14.4 24.4h3.2v-9.8h-3.2v9.8zM10.4 24.4h2.4v-9.8h-3.2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/delete_icon.svg
// module id = juLI
// module chunks = 14